import { AppliedCreditService } from "./v2/appliedCredits.service";
import { CampusService } from "./v2/campus.service";
import { CatalogService } from "./v2/catalog.service";
import { CourseLevelService } from "./v2/courseLevel.service";
import { EnrollmentService } from "./v2/enrollments.service";
import { FileService } from "./v2/file.service";
import { FinancesService } from "./v2/finances.service";
import { KitsService } from "./v2/kits.service";
import { InventoryService } from "./v2/inventory.service";
import { PurchaseService } from "./v2/purchases.service";
import { StockOpsService } from "./v2/stockops.service";
import { SalesService } from "./v2/sales.service";
import { InvoiceService } from "./v2/invoice.service";
import { PaymentService } from "./v2/payment.service";
import { PaymentMethodsService } from "./v2/paymentMethod.service";
import { RecipientAccountsService } from "./v2/recipientAccount.service";
import { RoleService } from "./v2/role.service";
import { ScheduleService } from "./v2/schedule.service";
import { AttendanceService } from "./v2/attendance.service";
import { StudentService } from "./v2/student.service";
import { BanksService } from "./v2/banks.service";
import { OtherIncomesService } from "./v2/otherIncomes.service";
import { EmployeeService } from "./v2/employee.service";
import { EnrollmentRequestsService } from "./v2/enrollmentRequests.service";
import { EnrollmentPrerequestsService } from "./v2/enrollmentPrerequests.service";
import { PlantillasService } from "./v2/plantillas.service";
import { NumerosService } from "./v2/numeros.service";
import { WappdriveService } from "./v2/wappdrive.service";
import { TelefoniaService } from "./v2/telefonia.service";
import { ProspectsService } from "./v2/prospects.service";
import { PaymentIntentsService } from "./v2/paymentIntents.service";

class HttpManager {
    private static instance: HttpManager;
    public appliedCreditService: AppliedCreditService;
    public attendanceService: AttendanceService;
    public banksService: BanksService;
    public campusService: CampusService;
    public catalogService: CatalogService;
    public courseLevelService: CourseLevelService;
    public enrollmentService: EnrollmentService;
    public employeeService: EmployeeService;
    public fileService: FileService;
    public financesService: FinancesService;
    public kitsService: KitsService;
    public inventoryService: InventoryService;
    public purchaseService: PurchaseService;
    public stockOpsService: StockOpsService;
    public salesService: SalesService;
    public invoiceService: InvoiceService;
    public otherIncomesService: OtherIncomesService;
    public paymentMethodService: PaymentMethodsService;
    public paymentService: PaymentService;
    public recipientAccountService: RecipientAccountsService;
    public roleService: RoleService;
    public scheduleService: ScheduleService;
    public studentService: StudentService;
    public enrollmentRequestsService: EnrollmentRequestsService;
    public enrollmentPrerequestsService: EnrollmentPrerequestsService;
    public plantillasService: PlantillasService;
    public numerosService: NumerosService;
    public wappdriveService: WappdriveService;
    public telefoniaService: TelefoniaService;
    public prospectsService: ProspectsService;
    public paymentIntentsService: PaymentIntentsService;

    constructor() {
        this.appliedCreditService = new AppliedCreditService();
        this.attendanceService = new AttendanceService();
        this.banksService = new BanksService();
        this.campusService = new CampusService();
        this.catalogService = new CatalogService();
        this.courseLevelService = new CourseLevelService();
        this.enrollmentService = new EnrollmentService();
        this.employeeService = new EmployeeService();
        this.fileService = new FileService();
        this.financesService = new FinancesService();
        this.kitsService = new KitsService();
        this.inventoryService = new InventoryService();
        this.purchaseService = new PurchaseService();
        this.stockOpsService = new StockOpsService();
        this.salesService = new SalesService();
        this.invoiceService = new InvoiceService();
        this.otherIncomesService = new OtherIncomesService();
        this.paymentMethodService = new PaymentMethodsService();
        this.paymentService = new PaymentService();
        this.recipientAccountService = new RecipientAccountsService();
        this.roleService = new RoleService();
        this.scheduleService = new ScheduleService();
        this.studentService = new StudentService();
        this.enrollmentRequestsService = new EnrollmentRequestsService();
        this.enrollmentPrerequestsService = new EnrollmentPrerequestsService();
        this.plantillasService = new PlantillasService();
        this.numerosService = new NumerosService();
        this.wappdriveService = new WappdriveService();
        this.telefoniaService = new TelefoniaService();
        this.prospectsService = new ProspectsService();
        this.paymentIntentsService = new PaymentIntentsService();
    }

    public static getInstance(): HttpManager {
        if (!HttpManager.instance) {
            HttpManager.instance = new HttpManager();
        }
        return HttpManager.instance;
    }
}

export default HttpManager;